import { isbot } from 'isbot'

export const isBot = () => {
    if (typeof window === 'undefined') {
        return false
    }

    return navigator?.userAgent ? isbot(navigator?.userAgent) : false
}
